<template>
  <a :href="`#${identifierId}`">
    <v-btn text rounded="pill" class="pa-0 mx-3">
      <span :class="[getActiveClass, 'px-2', 'py-1']">
        <slot></slot>
      </span>
    </v-btn>
  </a>
</template>

<script>
export default {
  name: 'NavBarItem',

  props: {
    identifierId: String,
  },

  data: () => ({
    viewingSection: '',
  }),

  computed: {
    isActive() {
      return this.viewingSection == this.identifierId;
    },
    getActiveClass() {
      return this.isActive ? 'active-section' : '';
    },
  },

  mounted() {
    // here onwards is for navbar intersectionObserver
    let options = {
      root: document.querySelector('#scrollArea'),
      rootMargin: '0px',
      threshold: 0.5,
    };

    // eslint-disable-next-line
    let callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.target.id == '') {
          this.viewingSection = 'tech-projects';
        } else {
          this.viewingSection = entry.target.id;
        }
      });
    };

    window.addEventListener(
      'load',
      // eslint-disable-next-line
      event => {
        let observer = new IntersectionObserver(callback, options);
        const sectionsToObserve = [
          '#about-me',
          '#tech-stacks',
          '#tech-projects',
          '#work-experience',
          '.project-card',
        ];
        sectionsToObserve.forEach(item => {
          const element = document.querySelector(item);
          observer.observe(element);
        });
      },
      false
    );
  }
};
</script>

<style>
.active-section {
  border: 1px solid black;
  border-radius: 1em;
  font-style: italic;
}
</style>
